import '@ids/style-modal-v19';
import '../Modal.css';
import './PurchaseConfirmationModal.css';

import { Ui24Check } from '@ids/react-icons';

import PurchaseConfirmationCard from '../../../components/purchase-confirmation-card/PurchaseConfirmationCard';
import type { Content } from '../../../global-types/Content';
import useTracking from '../../../hooks/useTracking';
import { renderContent } from '../../../utils/renderContent';

type PurchaseConfirmationModalProps = {
  content: Content;
  viewId: number | undefined;
  modalOpen: boolean;
};

function PurchaseConfirmationModal({ content, viewId, modalOpen }: PurchaseConfirmationModalProps) {
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const trackVisibilityElement = useTracking(content, modalOpen ? viewId : undefined);

  if (!view) return null;

  const { texts } = renderContent({
    view,
    trackVisibilityElement,
  });

  return (
    <div
      className="if modal-v19-content gap-16 small-padding flex-column background-beige-200 #F6F3F0"
      id="modal-v19-content"
    >
      <div className="if flex size-w-100p flex-center">
        <div className="circle">
          <Ui24Check />
        </div>
      </div>
      <div className="if flex-column flex-center text-align-center">{texts.slice(0, 2)}</div>
      <div className="if flex-center flex-column gap-24">
        {view.viewElements.purchaseConfirmationDetails && (
          <PurchaseConfirmationCard details={view.viewElements.purchaseConfirmationDetails} />
        )}
        {texts.slice(2)}
      </div>
    </div>
  );
}

export default PurchaseConfirmationModal;
